import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-selectedanalytics',
  templateUrl: './selectedanalytics.component.html',
  styleUrls: ['./selectedanalytics.component.css']
})
export class SelectedanalyticsComponent implements OnInit {
  @Input('token') token: any;
  @Input('parentRouteId') parentRouteId: any;
  @Input('loan') loan: any;
  constructor() { }

  ngOnInit() {
  }

}
